import DuplicateServiceModal from './DuplicateServiceModal';

export default DuplicateServiceModal;
